import { _ } from 'lodash';

export default class RestConfiguration {
  static BASE_URL = 'https://apialmoukawilchaabi.gbp.ma'; //'http://10.3.110.23:8080/landingpage'

  static timeOutLow = {
    response: 40000, // Wait 30 seconds for the server to start sending,
    deadline: 40000, // but allow 20 seconds for the file to finish loading.
  };

  static timeOutMiddle = {
    response: 35000, // Wait 35 seconds for the server to start sending,
    deadline: 40000, // but allow 40 seconds for the file to finish loading.
  };

  static timeOutHigh = {
    response: 45000, // Wait 45 seconds for the server to start sending,
    deadline: 60000, // but allow 60 seconds for the file to finish loading.
  };

  static build = (url, params) => {
    let s = url;
    params.forEach((prm) => {
      for (const key of Object.keys(prm)) {
        s = _.replace(s, `{${key}}`, prm[key]);
      }
    });
    return s;
  };

  static B_API = `${RestConfiguration.BASE_URL}/landingpage/api`;

  static B_PUBLIC_API = `${RestConfiguration.BASE_URL}/public` + `/api`;

  static FORM_CONTROLLER = `${RestConfiguration.B_API}/forms/`;

  static FIELDS_CONTROLLER = `${RestConfiguration.B_API}/fields/borne/`;

  // Fields Controller :
  static FIELDS_DATA = {
    url: RestConfiguration.FIELDS_CONTROLLER,
    type: 'GET',
  };

  // Forms Controller :
  static UPLOAD_FORM = { url: RestConfiguration.FORM_CONTROLLER, type: 'POST' };
}
